// extracted by mini-css-extract-plugin
export default {"calendar-event-modal":"styles_calendar-event-modal__G6gI4"};